import type { FormDefaults, FormSums } from '~/types/defaults'
import type { SiteLang, SiteOrg } from '~/types/env'
import type { FormType } from '~/types/forms'

const formSpecificSumsDefaults = (siteLang: SiteLang, formType: FormType) => {
  const defaults: Record<SiteLang | 'default', Record<FormType, FormSums>> = {
    sv: {
      donation: { defaultSum: 500, sums: [500, 250, 100], minSum: 25 },
      companyDonation: { defaultSum: 5000, sums: [5000, 3000, 1000], minSum: 500 },
      monthly: { defaultSum: 500, sums: [500, 250, 100], minSum: 50 },
      giftcert: { defaultSum: 500, sums: [500, 250, 100], minSum: 30 },
    },
    uk: {
      donation: { defaultSum: 25, sums: [50, 25, 10], minSum: 1 },
      companyDonation: { defaultSum: 25, sums: [50, 25, 10], minSum: 10 },
      monthly: { defaultSum: 25, sums: [50, 25, 10], minSum: 10 },
      giftcert: { defaultSum: 25, sums: [50, 25, 10], minSum: 10 },
    },
    en: {
      donation: { defaultSum: 25, sums: [50, 25, 10], minSum: 1 },
      companyDonation: { defaultSum: 25, sums: [50, 25, 10], minSum: 10 },
      monthly: { defaultSum: 25, sums: [50, 25, 10], minSum: 10 },
      giftcert: { defaultSum: 25, sums: [50, 25, 10], minSum: 10 },
    },
    es: {
      donation: { defaultSum: 25, sums: [50, 25, 10], minSum: 1 },
      companyDonation: { defaultSum: 25, sums: [50, 25, 10], minSum: 10 },
      monthly: { defaultSum: 25, sums: [50, 25, 10], minSum: 10 },
      giftcert: { defaultSum: 25, sums: [50, 25, 10], minSum: 10 },
    },
    fi: {
      donation: { defaultSum: 25, sums: [50, 25, 10], minSum: 1 },
      companyDonation: { defaultSum: 25, sums: [50, 25, 10], minSum: 10 },
      monthly: { defaultSum: 25, sums: [50, 25, 10], minSum: 10 },
      giftcert: { defaultSum: 25, sums: [50, 25, 10], minSum: 10 },
    },
    default: {
      donation: { defaultSum: 25, sums: [50, 25, 10], minSum: 1 },
      companyDonation: { defaultSum: 25, sums: [50, 25, 10], minSum: 10 },
      monthly: { defaultSum: 25, sums: [50, 25, 10], minSum: 10 },
      giftcert: { defaultSum: 25, sums: [50, 25, 10], minSum: 10 },
    },
  }

  return defaults[siteLang][formType] || defaults.default[formType]
}

export const useFormDefaults = ({
  formType,
  siteOrg,
  siteLang,
}: {
  formType: FormType
  siteOrg: SiteOrg
  siteLang: SiteLang
}) => {
  const formDefaults: FormDefaults = {
    sums: formSpecificSumsDefaults(siteLang, formType),
    countryCode:
      siteOrg === 'djurensratt' && siteLang === 'sv' ? 'SE' : siteLang === 'uk' ? 'UA' : 'EN', // Djurens Rätt should have SE as default country, Ukrainian language should have UA as default country, otherwise leave blank
  }

  return formDefaults
}
